import {useEffect, useState} from "react";
import _ from "lodash";
import React from "react";

import {Form} from "react-bootstrap";
import {Accordion, AccordionTab} from "primereact/accordion";
import {Checkbox} from "primereact/checkbox";

export const Admittances = ({admittanceList, filterType, checkedFiltersObject, setCheckedFiltersObject}) => {

    const [admittanceListGrouped, setAdmittanceListGrouped] = useState([])
    const [keys, setKeys] = useState([])

    const isCheck = (id) => {
        for(let i =0; i < checkedFiltersObject[filterType].length; i++){
            if(checkedFiltersObject[filterType][i].Id ===id){
                return true;
            }
        }
        return false
    }

    const handleAdmittanceChange = (e) => {
        debugger
        console.log(e.target.id)
        console.log(e.target.checked)

        let isExist = _.find(checkedFiltersObject[filterType], ['Id', e.target.id]);
        let deepClone = _.cloneDeep(checkedFiltersObject);

        if(e.target.checked && !isExist){
            const filterModel = {Id: e.target.id, Name: e.target.value};
            deepClone[filterType].push(filterModel)
            setCheckedFiltersObject(deepClone);
        }
        else if(!e.target.checked && isExist){
            _.remove(deepClone[filterType], function(n) {
                return n.Id === e.target.id
            });
            setCheckedFiltersObject(deepClone);
        }
    }

    if(!keys){
        return (<div>Допусков нет</div>)
    }

    useEffect(() => {
        //if(admittanceList.length !== 0){
        if(admittanceList){
            try {
                const grouped = _.groupBy(admittanceList, 'AdmittanceName');
                const keys =  _.keys(grouped);
                setKeys(keys);
                setAdmittanceListGrouped(grouped);
            }
            catch (err){
                console.log(err)
            }
        }
    },[admittanceList])

    return (
        <div>
            {keys.map((admittanceKey, index) =>
                    <Accordion key={admittanceKey} >
                        <AccordionTab header={
                            <div className="flex align-items-center">
                                <i className="pi pi-book mr-2"></i>
                                <span className="vertical-align-middle">{admittanceKey.toString()}</span>
                            </div>
                        }>
                            {admittanceListGrouped[admittanceKey.toString()].map((admittance, index) =>
                                /* <Form.Check onChange={handleSpecChange} type="checkbox" id={spec.Id} key={spec.Id.toString()} label={spec.SpecificationValue} />*/
                                <div  key={admittance.Id.toString()}>
                                    <Checkbox onChange={handleAdmittanceChange} type="checkbox" id={admittance.Id} value={admittance.AdmittanceValue} label={admittance.AdmittanceValue}  checked={isCheck(admittance.Id)}/*checked={filter.IsChecked}*/ />
                                    <label htmlFor="ingredient1" className="ml-2">{admittance.AdmittanceValue}</label>
                                </div>
                            )}
                        </AccordionTab>
                    </Accordion>
            )}
        </div>
    )
}